<template>
  <v-menu>
    <template #activator="{ props }" >
      <!-- Div visual previo al click -->
      <div v-bind="props" :class="frontStyle === 'discord' ? 'discord-dp' : 'classic-dp'" class="no-user-select">
        <span class="mdi mdi-application-outline"></span>
        Páginas
      </div>
    </template>

    <!-- Lista de páginas post click -->
    <v-list>
      <v-list-item v-for="page in pages" :key="page.index" @click="goToPage(page.index)">
        # {{ page.name }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "PagesDropdown",
  props: {
    frontStyle: {
      type: String,
      default: "classic"
    }
  },
  computed: {
    pages() {
      return this.$store.state.project.pages;
    },
  },
  data() {
    return {
      isOpenDropDown: false,
    }
  },
  methods: {
    goToPage(pageIndex) {
      this.$router.push({
        name: "MeetingWarePage",
        params: {
          projectId: this.$route.params.projectId,
          pageIndex: pageIndex
        }
      });
    },
  },
}
</script>

<style scoped>
.discord-dp {
  padding-left: 10px;
  margin: 5px 0px;
  margin-bottom: 5px;
}

.classic-dp{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>